export enum TectoyLCDFuncaoEnum {
  'INICIALIZAR' = 1,
  'LIGAR_LCD' = 2,
  'DESLIGAR_LCD' = 3,
  'LIMPAR_TELA' = 4,
}

export enum TectoyLampStatusEnum {
  'LIGAR' = 0,
  'DESLIGAR' = 1,
}

export enum TectoyLampLedEnum {
  'LED_1' = 'Led-1',
  'LED_2' = 'Led-2',
  'LED_3' = 'Led-3',
  'LED_4' = 'Led-4',
  'LED_5' = 'Led-5',
  'LED_6' = 'Led-6',
}

export enum TectoyBarcodeFormatEnum {
  'UPC_A' = 0,
  'UPC_E' = 1,
  'EAN_13' = 2,
  'EAN_8' = 3,
  'CODE_39' = 4,
  'ITF' = 5,
  'CODABAR' = 6,
  'CODE_93' = 7,
  'CODE_128' = 8,
  'QR_CODE' = 9,
}
